import { render, staticRenderFns } from "./parent-view.vue?vue&type=template&id=717359be"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717359be')) {
      api.createRecord('717359be', component.options)
    } else {
      api.reload('717359be', component.options)
    }
    module.hot.accept("./parent-view.vue?vue&type=template&id=717359be", function () {
      api.rerender('717359be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parent-view.vue"
export default component.exports